// 商品詳細画面の購入ボタンブロックから、Shoppayボタンのみを非表示
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(() => {
      document.querySelectorAll('shop-pay-wallet-button').forEach(el => el.style.display = 'none');
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll('shop-pay-wallet-button').forEach(el => el.style.display = 'none');
});
